module.exports = __webpack_public_path__ + "img/pic1.e4dcfa90.jpg";